import * as React from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';
import { cn } from '@/utils/cn';
import styles from './Switch.module.scss';
import type { SwitchProps } from './Switch.types';

export const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitive.Root>,
  SwitchProps
>(({ className, label, description, id, ...props }, ref) => {
  const generatedId = React.useId();
  const switchId = id ?? generatedId;

  if (!label && !description) {
    return (
      <SwitchPrimitive.Root
        className={cn(styles.switch, className)}
        ref={ref}
        id={switchId}
        {...props}
      >
        <SwitchPrimitive.Thumb className={styles.switch__thumb} />
      </SwitchPrimitive.Root>
    );
  }

  return (
    <div className={cn(styles.switchWrapper, className)}>
      <div className={styles.switchWrapper__content}>
        {label && (
          <label htmlFor={switchId} className={styles.switchWrapper__label}>
            {label}
          </label>
        )}
        {description && <span className={styles.switchWrapper__description}>{description}</span>}
      </div>

      <SwitchPrimitive.Root className={styles.switch} ref={ref} id={switchId} {...props}>
        <SwitchPrimitive.Thumb className={styles.switch__thumb} />
      </SwitchPrimitive.Root>
    </div>
  );
});

Switch.displayName = 'Switch';
